module.exports = __webpack_public_path__ + "static/media/aboutUsVideo-2.5cb615fe.png";